<mat-card class="menupannel">
  <div class="resUser">
    <button mat-flat-button (click)="showMyDrive()">
      <mat-icon>menu</mat-icon> My Drive 
    </button>
  </div>
  <div class="d">
    <button mat-flat-button (click)="showDocDetail()">
      <mat-icon>keyboard_arrow_left</mat-icon> Details
    </button> 
  </div>
</mat-card>

  <div class="coreholder" fxLayout="row">

    <!-- My Drive -->

    <mat-card class="myDrive" [ngClass]="{'open': showmyDrive }">
        <app-left-menu></app-left-menu>
    </mat-card>
  
    <div class="myDriveOverlay" (click)="showMyDrive()" [ngClass]="{'open': showmyDrive }"></div>
      
    <!-- My Drive -->
  
    <!-- Core page Structure -->
    <div class="corepages">
  
      <!-- Filter -->
      <mat-card class="filter">
        <label>Inbox</label>
        <div class="slAct">        
          <button (click)="deleteInboxProjects()" *ngIf="SelectedRecordForDeleFav" mat-icon-button><mat-icon>delete_outline</mat-icon></button>
        </div>

        <div class="projectSearch">
      
          <button class="searchbtn" [disabled]="pageModelData.searchValue==''"  mat-icon-button aria-label="Clear">
            <mat-icon (click)="SearchFilter()">search</mat-icon>
          </button>
         
          <input placeholder="Search Inbox" type="text"  maxlength="30" [(ngModel)]="pageModelData.searchValue" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
                    
          </div>

        <!-- <mat-form-field appearance="">
          <mat-label>Search... </mat-label>
          <input matInput type="text"  maxlength="30" [(ngModel)]="pageModelData.searchValue" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
          <button [disabled]="pageModelData.searchValue==''" matSuffix mat-icon-button aria-label="Clear">
            <mat-icon (click)="SearchFilter()">search</mat-icon>
          </button>
          
        </mat-form-field> -->
  
        <!-- <button  class="filterbtn" mat-icon-button>
          <mat-icon>filter_list</mat-icon>
        </button> -->

        <!-- <div class="add">
          <button mat-flat-button color="primary" (click)="CreatePdfForm()">Create PDF Form</button>
        </div> -->

        <div class="add">
          <button mat-button color="primary" [matMenuTriggerFor]="menu"><mat-icon>add</mat-icon> Create</button>
          <mat-menu #menu="matMenu">
          <button mat-menu-item  (click)="CreatePdfForm(true)">PDF Form</button>
          <button mat-menu-item  (click)="CreateAuditForm(true)">Tabular Form</button>
          <button mat-menu-item  (click)="CreateHTMLForm(true)">HTML Form</button>
          <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreatePdfForm(false)">Master PDF Form</button>
          <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreateAuditForm(false)">Master Tabular Form</button>
          <button mat-menu-item *ngIf="ShowMasterTemplate" (click)="CreateHTMLForm(false)">Master Web Form</button>
        </mat-menu>       
        </div>
      </mat-card>
      <!-- Filter -->
   
      <mat-card class="emailList">
     
        <mat-table  [dataSource]="dataSource" matSort matSortDisableClear matSortDirection="asc">
          <ng-container matColumnDef="projectId">
            <div *matHeaderCellDef class="check">
               <mat-checkbox color="primary" [disabled]="noRecordFound"
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
            </div>
            <div *matCellDef="let inbox" class="check">
              <mat-checkbox color="primary" (change)="isAllSelectedRow($event,inbox)"
              (change)="$event ? selection.toggle(inbox) : null"
              [checked]="selection.isSelected(inbox)"></mat-checkbox>
            </div>
          </ng-container>
  
          <ng-container matColumnDef="subject">
            <div *matHeaderCellDef mat-sort-header class="subject">
              Subject
            </div>
  
            <div *matCellDef="let inbox" class="subject" (click)="fillInboxItemParticipantList(inbox)" matTooltip="{{ inbox.subject }}" matTooltipClass="tooltip">
              <h4>{{ inbox.subject }}</h4>
              <p>From: {{ inbox.fromName|titlecase }}</p>
            </div> 
          </ng-container> 
          
          <ng-container matColumnDef="projectName">
            <div *matHeaderCellDef mat-sort-header class="subject">
              Project Name
            </div>
  
            <div *matCellDef="let inbox" class="subject" (click)="fillInboxItemParticipantList(inbox)" matTooltip="{{ inbox.projectName }}" matTooltipClass="tooltip">
              <h4>{{ inbox.projectName }}</h4>            
            </div> 
          </ng-container> 


          
         

          <ng-container matColumnDef="status">
            <div *matHeaderCellDef mat-sort-header class="relation">
              Status
            </div>
  
            <div *matCellDef="let inbox" class="relation" (click)="fillInboxItemParticipantList(inbox)">
              <!-- <p>{{ inbox.relationName }}</p> -->
              <p *ngIf="inbox.projectStatus==0">Drafted</p>
              <p *ngIf="inbox.projectStatus==1">Pending</p>
              <p *ngIf="inbox.projectStatus==2">In-progress</p>
              <p *ngIf="inbox.projectStatus==3">Completed</p>
              <p *ngIf="inbox.projectStatus==4">Withdraw</p>
              <p *ngIf="inbox.projectStatus==5">Declined</p>
            </div> 
          </ng-container>  

          <ng-container matColumnDef="receivedOn">
            <div *matHeaderCellDef mat-sort-header class="update">Received On</div>
            <p *matCellDef="let inbox" class="update sepDateTime" (click)="fillInboxItemParticipantList(inbox)"> 
              <span>{{ inbox.createdOn+'Z' | date: "MM/dd/yyyy"}}</span>
              <!-- <span class="time">{{ inbox.createdOn | date: "h:mm a"}}</span> -->
              <span class="time">{{ inbox.createdOn+'Z' | date: "h:mm a" }}</span>
            </p>
          </ng-container>
          
          <ng-container matColumnDef="action">
            <div class="action" *matHeaderCellDef>Action</div>
  
          <div class="action" *matCellDef="let inbox">            
            
            <a *ngIf="inbox.status==0" mat-icon-button matTooltipClass="tooltip" target="_blank" [href]='inbox.signHref' matTooltip="Sign" color="primary">
              <mat-icon>border_color</mat-icon>
            </a>

            <a *ngIf="inbox.status==1" mat-icon-button matTooltipClass="tooltip" target="_blank" [href]='inbox.signHref' matTooltip="View" color="basic">
              <mat-icon>visibility</mat-icon>
            </a>


            <a *ngIf="inbox.status==2" mat-icon-button matTooltipClass="tooltip" target="_blank" [href]='inbox.signHref' matTooltip="Approve" color="primary">
              <mat-icon>check_circle</mat-icon>
            </a>

            <button mat-icon-button class="options" [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu"  xPosition="before">
              <!-- <button mat-menu-item matTooltipClass="tooltip" matTooltip="Decline" ><mat-icon>thumb_down_alt</mat-icon> Decline</button> -->
              <button mat-menu-item (click)="deleteInboxProject(inbox.projectInboxSentId)"  matTooltipClass="tooltip" matTooltip="Move to trash">
                <mat-icon>delete_outline</mat-icon> Move to trash
              </button>

              <button mat-menu-item [disabled]="inbox.projectStatus!=3" (click)="downloadDocument(inbox)"  matTooltipClass="tooltip" matTooltip="Download">
                <mat-icon>cloud_download</mat-icon> Download
              </button>

            </mat-menu>
        
          </div>
          </ng-container>
  
          <mat-header-row  class="list ehead" *matHeaderRowDef="displayedColumns"></mat-header-row>
  
          <mat-row (click)="showParticipantDetail(row)"
          [ngClass]="{'selected_row': row.projectInboxSentId === projectInboxSentId }" class="list erow" *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
  
        <div *ngIf="noRecordFound" class="noRecordFound" >No Record Found</div>

         
      <mat-paginator *ngIf="!noRecordFound" [length]="paginatorTotalLength"
      [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 30]"
      itemsPerPageLabel="Records Per Page" showFirstLastButtons
      (page)="pageEventPropogate($event)">
      </mat-paginator>
      </mat-card> 

    
    </div>


    <!-- Core page Structure -->
    <!-- Document Detail  -->
    <mat-card class="documentDetail" [ngClass]="{ open: groupDetail }">
      <app-group-detail     
      [participantList]="participantList" [selectedSentItem]="selectedInboxItem"></app-group-detail>
    </mat-card>
    <div class="documentDetailOverlay" (click)="showDocDetail()" [ngClass]="{'open': groupDetail }"></div>

    <!-- Document Detail -->
  
  </div>
  
  


  















